<template>
	<div id="app">
		<router-view />
	</div>
</template>

<script>
export default {
	name: 'App',
	created() {
		if (document.getElementById('Loading'))
			document.getElementById('Loading').remove()
	}
}
</script>
<style lang="less">
#app {
	/deep/ input[aria-hidden='true'] {
		display: none !important;
	}

	/deep/.el-radio:focus:not(.is-focus):not(:active):not(.is-disabled)
		.el-radio__inner {
		box-shadow: none !important;
	}
}
</style>
<style>
/* @import url('https://at.alicdn.com/t/font_2680795_kgwfmiv7jbn.css'); */

/* @import url('/styles/iconfont.css'); */
/* 滚动条优化 start */
::-webkit-scrollbar {
	width: 3px;
	height: 3px;
}
::-webkit-scrollbar-track {
	background: #f6f6f6;
	border-radius: 2px;
}
::-webkit-scrollbar-thumb {
	background: #cdcdcd;
	border-radius: 10px;
}
::-webkit-scrollbar-thumb:hover {
	background: #747474;
}
::-webkit-scrollbar-corner {
	background: #f6f6f6;
}
/* 滚动条优化 end */

/* 表格 */
.el-table .cell {
	line-height: 45px;
}
.el-table .el-table__cell {
	padding: 0;
}
.el-input__inner::-webkit-input-placeholder {
	/* WebKit browsers */
	color: #656c6c;
}
.el-input__inner:-moz-placeholder {
	/* Mozilla Firefox 4 to 18 */
	color: #656c6c;
}
.el-input__inner::-moz-placeholder {
	/* Mozilla Firefox 19+ */
	color: #656c6c;
}
.el-input__inner:-ms-input-placeholder {
	/* Internet Explorer 10-11 */
	color: #656c6c;
}
.el-input__inner::placeholder {
	/* Microsoft Edge 和最新版本的Opera支持 */
	color: #656c6c;
}
/* input框 */
.el-input--medium .el-input__inner {
	height: 50px;
	line-height: 50px;
	/* font-size: 12px; */
}
.el-select .el-input .el-select__caret {
	font-size: 12px;
}
.el-input--medium .el-input__icon {
	line-height: 30px;
}
label {
	font-weight: normal !important;
}
.el-input__inner {
	/* background-color: #cee7ea;
	border: 1px solid transparent; */
}
.el-range-editor.el-input__inner {
	height: 30px;
}
.el-popover__title {
	font-size: 14px !important;
	text-align: center;
}
/* 表格 */
.el-table .cell {
	font-size: 14px !important;
}
.el-tag {
	font-size: 14px !important;
}
.el-select-dropdown__item {
	text-align: center;
}
.el-tooltip__popper.is-dark {
	max-width: 280px;
	background: #fff;
	color: #303133;
	border: 1px solid #e6ebf5;
}
/* 全站 tooltip 样式修改 */
.el-tooltip__popper {
	box-shadow: 0 2px 12px 0px rgb(0 0 0 / 15%);
}
.el-tooltip__popper[x-placement^='right'] .popper__arrow {
	border-right-color: #e6ebf5 !important;
	filter: drop-shadow(0 2px 12px rgba(0, 0, 0, 0.03));
}
.el-tooltip__popper[x-placement^='right'] .popper__arrow::after {
	border-right-color: #fff !important;
}
.el-tooltip__popper[x-placement^='top'] .popper__arrow::after {
	border-top-color: #fff !important;
}
.el-tooltip__popper[x-placement^='top'] .popper__arrow {
	border-top-color: #e6ebf5 !important;
	filter: drop-shadow(0 2px 12px rgba(0, 0, 0, 0.03));
}
.el-tooltip__popper[x-placement^='bottom'] .popper__arrow::after {
	border-bottom-color: #fff !important;
}
.el-tooltip__popper[x-placement^='bottom'] .popper__arrow {
	border-bottom-color: #e6ebf5 !important;
	filter: drop-shadow(0 2px 12px rgba(0, 0, 0, 0.03));
}
.el-tooltip__popper[x-placement^='left'] .popper__arrow::after {
	border-left-color: #fff !important;
}
.el-tooltip__popper[x-placement^='left'] .popper__arrow {
	border-left-color: #e6ebf5 !important;
	filter: drop-shadow(0 2px 12px rgba(0, 0, 0, 0.03));
}
</style>
